module.exports = __webpack_public_path__ + "media/images/pic/anime/box-blog-type2-024ff7689ee4a49eaff0fb57a8317e07.svg";